import type { SlideContentBlock } from '@hcc/types';
import { LeafBlockList } from './BlockEditorList';

type ColumnsBlock = Extract<SlideContentBlock, { type: 'columns' }>;

/** Side-by-side cells, each a leaf-only block list. */
export function ColumnsBlockEditor({
  block,
  onChange,
}: {
  block: ColumnsBlock;
  onChange: (next: ColumnsBlock) => void;
}) {
  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
      <div className="rounded-token-sm bg-surface-2 p-2">
        <span className="mb-2 block text-xs font-medium uppercase tracking-wide text-fg-dim">
          Left
        </span>
        <LeafBlockList blocks={block.left} onChange={(left) => onChange({ ...block, left })} />
      </div>
      <div className="rounded-token-sm bg-surface-2 p-2">
        <span className="mb-2 block text-xs font-medium uppercase tracking-wide text-fg-dim">
          Right
        </span>
        <LeafBlockList blocks={block.right} onChange={(right) => onChange({ ...block, right })} />
      </div>
    </div>
  );
}
